import { GridColDef } from '@mui/x-data-grid';

export const getStudentTransportReportColumns = (): GridColDef[] => {
  return [
    {
      field: 'id',
      headerName: 'Id',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'name',
      headerName: 'Student Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'enrollmentNo',
      headerName: 'Enrollment No.',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'courseInfo',
      headerName: 'Class',
      minWidth: 120,
      flex: 1,
      valueGetter: (value: any, row: any) => {
        const grade = row?.courseInfo?.grade || '';
        const division = row?.courseInfo?.division || '';
        return `${grade || ''} ${division || ''}`;
      },
      renderCell: (params) => {
        const grade = params.row?.courseInfo?.grade || '';
        const division = params.row?.courseInfo?.division || '';
        return `${grade || ''} ${division || ''}`;
      }
    },
    {
      field: 'parents',
      headerName: 'Parents',
      minWidth: 240,
      flex: 1,
      renderCell: (params) => {
        const parents = params.row.parents.join(',');
        return `${parents}`;
      }
    },
    {
      field: 'pickUp',
      headerName: 'Pick Up',
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        return `${params.row.pickUp.join(',')}`;
      }
    },
    {
      field: 'pickUpBus',
      headerName: 'Pick Up Bus',
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return `${params.row.pickUpBus.join(',')}`;
      }
    },
    {
      field: 'dropOff',
      headerName: 'Drop Off',
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        return `${params.row.dropOff.join(',')}`;
      }
    },
    {
      field: 'dropOffBus',
      headerName: 'Drop Off Bus',
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return `${params.row.dropOffBus.join('')}`;
      }
    }
  ];
};
